import React, { useState, useEffect } from "react";

import Navbar from "../Navbar";
import Header from "../Header";

import "./styles.css";

import * as Material from "@mui/material";

import { useChallenge } from "../../contexts/ChallengeContext";
import ChatsBox from "../../contexts/ChatContext";

import { useNavigate, useLocation } from "react-router-dom";


export default function Screen({ children, title, className = "" }) {
  const [snack, setSnack] = useState(null);

  const { currentChallenge } = useChallenge();

  const { pathname } = useLocation();


  window.setSnackbar = setSnack;

  if (title) document.title = title;

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 10);
  }, [pathname]);

  return (
    <div className={"screen " + className}>
      {snack && (
        <Material.Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={!!snack}
          onClose={() => setSnack(null)}
          message={snack}
        />
      )}
      <Navbar />
      <Header />

      <div className="screen-container pt-2">
        <div className="screen-parent">
          {title && <h1 className="page-title mt-2">{title}</h1>}
          {children}
        </div>
        <ChatsBox />
      </div>
    </div>
  );
}
